import {useEffect} from 'react';
import {useIntl} from 'react-intl';

import {getDynamicSolanaChainIdFromNetwork} from '@stripe-internal/wallet-connect-wrapper';

import {getChainIdFromNetwork} from 'src/components/Wallet/constants';
import {setValue, useSelector} from 'src/v2/state/store';
import {useWalletConnectionClient} from 'src/v2/state/walletConnection';
import {handleError} from 'src/v2/components/error/handleError';

export const useNetworkSwitchingEffect = () => {
  const intl = useIntl();
  const walletClient = useWalletConnectionClient();
  const chainId = useSelector(
    (state) => state.walletConnection.activeWallet?.chainId,
  );
  const network = useSelector(
    (state) => state.walletConnection.activeWallet?.network,
  );
  const livemode = useSelector((state) => state.livemode);

  useEffect(() => {
    const switchNetworkIfMismatched = async () => {
      if (!chainId || !network) {
        return;
      }

      const expectedChainId =
        network === 'solana'
          ? getDynamicSolanaChainIdFromNetwork(network, livemode)
          : getChainIdFromNetwork(network, livemode);

      if (expectedChainId === chainId) {
        return;
      }

      setValue((state) => {
        state.overlay = 'NETWORK_SWITCH';
      });

      try {
        await walletClient.switchNetwork(expectedChainId);
      } catch (error) {
        handleError({error, intl, context: 'network_switch'});
      } finally {
        setValue((state) => {
          state.overlay = null;
        });
      }
    };

    switchNetworkIfMismatched();
  }, [chainId, network, livemode, walletClient, intl]);
};
